import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { InputBaseComponent } from 'src/app/inputs/input.base';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent extends InputBaseComponent implements OnInit {

  constructor() {
    super();
  }

  @Input() inputModel: File;
  @Input() uploadedUrl: string;
  @Input() errore: string;
  @Output() inputModelChange: EventEmitter<File> = new EventEmitter<File>();

  @ViewChild('fileName') fileNameSpan: ElementRef<HTMLSpanElement>;
  @ViewChild('inputField') inputField: ElementRef<HTMLInputElement>;

  ngOnInit() {
  }

  onFileOpen(ev: Event) {
    if (!this.disabled) {
      this.inputField.nativeElement.click();
    }
  }

  clearFile() {
    if (!this.disabled) {
      const file = this.inputField.nativeElement;
      file.files = null;
      const spanElem: HTMLSpanElement = this.fileNameSpan.nativeElement;
      spanElem.textContent = 'Nessun file selezionato';
      this.inputModel = null;
    }
  }

  onFileUploaded(ev: Event) {
    const uploaded: File = (ev.currentTarget as HTMLInputElement).files[0];
    if (uploaded&&uploaded.size < 5242880) {
      this.inputModel = uploaded;
      this.inputModelChange.emit(this.inputModel);
      const spanElem: HTMLSpanElement = this.fileNameSpan.nativeElement;
      spanElem.textContent = uploaded.name;
      if (spanElem.offsetWidth < spanElem.scrollWidth) {
        const marquee = document.createElement('marquee');
        marquee.textContent = uploaded.name;
        marquee.title = uploaded.name;
        // tslint:disable-next-line: deprecation
        marquee.behavior = 'alternate';
        // tslint:disable-next-line: deprecation
        marquee.scrollAmount = 1;
        marquee.onmouseover = () => {
          // tslint:disable-next-line: deprecation
          marquee.stop();
        };
        marquee.onmouseout = () => {
          // tslint:disable-next-line: deprecation
          marquee.start();
        };

        marquee.style.verticalAlign = 'middle';

        spanElem.textContent = '';
        spanElem.appendChild(marquee);
      }
    } else {
      this.inputModel = uploaded;
      this.inputModelChange.emit(this.inputModel);
    }
  }
}

